import _ from 'lodash';
import { constantCase } from 'change-case';

const merchantConfigurationServiceFactory = ($log, $q, $rootScope, endPoints, NewBackendService, LoginService, MerchantDetailService, $http, API_KEY_GOOGLE, StorageService) => {
  'ngInject';

  const notifyStoreConfigChange = () => {
    $rootScope.$broadcast('STORECONFIG_UPDATE');
  };

  const errors = {
    NOT_VAS_MERCHANT: 'NOT_VAS_MERCHANT'
  };

  const vasIds = {
    CHECKIN: 0,
    ORDERANDPAY: 1,
    MESSAGEOUTBOUND: 2,
    ORDERANDDELIVERY: 3,
    ORDERATTABLE: 4,
    ORDERANDPICK: 5,
    INVOICES: 6,
    CORPORATECASH: 7,
    OFFICEDELIVERY: 8,
    PAYWITHALIPAY: 50,
    PROJECTWITHALIPAY: 51,
    MOBILEPAYWITHALIPAY: 52
  };

  const merchantContactTypes = {
    phone: 0,
    email: 1,
    website: 2,
    facebook: 3,
    twitter: 4,
    image: 5,
    welcome: 6,
    times: 7
  };

  const isVasMerchant = (merchantProfile) => 'merchantStoreExtended' in merchantProfile;

  const getVasMerchant = () => $q((resolve, reject) => {
    LoginService.getMerchantProfile(false).then((merchantProfile) => {
      if (isVasMerchant(merchantProfile)) {
        resolve(merchantProfile.merchantStoreExtended);
      } else {
        reject({
          errorMessage: errors.NOT_VAS_MERCHANT
        });
      }
    }, reject);
  });

  const getVasServices = vasMerchant => {
    const services = {
      checkin: false,
      orderAndPay: false,
      taxation: true,
      messageOutbound: false,
      orderAndDelivery: false,
      officeDelivery: false,
      orderAndPick: false,
      orderAtTable: false,
      invoices: false,
      corporateCash: false,
      payWithAlipay: false,
      projectWithAlipay: false,
      mobilePayWithAlipay: false,
    };

    let storeConfiguration;

    try {
      storeConfiguration = vasMerchant.merchantVasViewCustomList;
    } catch (error) {
      $log.error('MerchantConfigurationService', 'getMerchantStoreConfiguration', error);
      storeConfiguration = undefined;
    }

    if (storeConfiguration) {
      services.checkin = _.some(storeConfiguration, {
        vasId: vasIds.CHECKIN,
        subscriptionStatus: 1
      });

      services.orderAndPay = _.some(storeConfiguration, {
        vasId: vasIds.ORDERANDPAY,
        subscriptionStatus: 1
      });

      services.messageOutbound = _.some(storeConfiguration, {
        vasId: vasIds.MESSAGEOUTBOUND,
        subscriptionStatus: 1
      });

      services.orderAndPick = _.some(storeConfiguration, {
        vasId: vasIds.ORDERANDPICK,
        subscriptionStatus: 1
      });

      services.orderAndDelivery = _.some(storeConfiguration, {
        vasId: vasIds.ORDERANDDELIVERY,
        subscriptionStatus: 1
      });

      services.officeDelivery = _.some(storeConfiguration, {
        vasId: vasIds.OFFICEDELIVERY,
        subscriptionStatus: 1
      });

      services.orderAtTable = _.some(storeConfiguration, {
        vasId: vasIds.ORDERATTABLE,
        subscriptionStatus: 1,
      });

      services.invoices = _.some(storeConfiguration, {
        vasId: vasIds.INVOICES,
        subscriptionStatus: 1,
      });

      services.corporateCash = _.some(storeConfiguration, {
        vasId: vasIds.CORPORATECASH,
        subscriptionStatus: 1,
      });

      services.orderAndDelivery = _.some(storeConfiguration, {
        vasId: vasIds.ORDERANDDELIVERY,
        subscriptionStatus: 1
      });

      services.payWithAlipay = _.some(storeConfiguration, {
        vasId: vasIds.PAYWITHALIPAY,
        subscriptionStatus: 1,
      });

      services.projectWithAlipay = _.some(storeConfiguration, {
        vasId: vasIds.PROJECTWITHALIPAY,
        subscriptionStatus: 1,
      });

      services.mobilePayWithAlipay = _.some(storeConfiguration, {
        vasId: vasIds.MOBILEPAYWITHALIPAY,
        subscriptionStatus: 1,
      });
    }
    return services;
  };

  const getMerchantStoreConfiguration = () => $q((resolve, reject) => {
    const settings = {
      isVasMerchant: false,
      services: {}
    };

    getVasMerchant().then((vasMerchant) => {
      settings.isVasMerchant = true;
      settings.services = getVasServices(vasMerchant);
      resolve(settings);
    }, (reason) => {
      if (typeof reason !== 'string' && 'errorMessage' in reason) {
        if (reason.errorMessage !== errors.NOT_VAS_MERCHANT) {
          reject(reason);
        } else {
          resolve(settings);
        }
      }
    });
  });

  const getConfigCateringVas = (configuration) => ({
    userContext: {},
    data: {
      request: {
        configCateringVasRequest: configuration
      }
    }
  });

  const getConfigCateringTaxationRequest = (merchant, configuration) => ({
    userContext: {},
    data: {
      request: {
        configCateringTaxationRequest: {
          invoiceEnabled: configuration.invoiceEnabled,
          sharePercentage: configuration.sharePercentage,
          vasId: configuration.vasId
        }
      }
    }
  });

  const getSubscribeMerchantVasRequest = configuration => ({
    userContext: {},
    data: {
      request: {
        subscribeMerchantVASRequest: {
          vasId: configuration.vasId,
          vasSubscribe: configuration.vasSubscribe | 0
        }
      }
    }
  });

  const getSaveContactInfoRequest = (contacts, mode) => {
    var body = [];
    body.push({ 'op': 'replace', 'path': '/name', 'value': contacts.name });
    body.push({ 'op': 'replace', 'path': '/visible', 'value': contacts.visible });
    { body.push({ 'op': 'replace', 'path': '/phoneNumber', 'value': contacts.phoneNumber }); }
    { body.push({ 'op': 'replace', 'path': '/email', 'value': contacts.email }); }
    { body.push({ 'op': 'replace', 'path': '/supportPhoneNumber', 'value': contacts.supportPhoneNumber }); }
    { body.push({ 'op': 'replace', 'path': '/supportEmail', 'value': contacts.supportEmail }); }
    { body.push({ 'op': 'replace', 'path': '/web', 'value': contacts.web }); }
    if (contacts.customName) { body.push({ 'op': 'replace', 'path': '/customName', 'value': contacts.customName }); }
    if (contacts.customValue) { body.push({ 'op': 'replace', 'path': '/customValue', 'value': contacts.customValue }); }
    { body.push({ 'op': 'replace', 'path': '/facebook', 'value': contacts.facebook }); }
    { body.push({ 'op': 'replace', 'path': '/twitter', 'value': contacts.twitter }); }
    { body.push({ 'op': 'replace', 'path': '/instagram', 'value': contacts.instagram }); }
    { body.push({ 'op': 'replace', 'path': '/youtube', 'value': contacts.youtube }); }
    { body.push({ 'op': 'replace', 'path': '/tiktok', 'value': contacts.tiktok }); }
    { body.push({ 'op': 'replace', 'path': '/openingHours', 'value': contacts.openingHours }); }
    { body.push({ 'op': 'replace', 'path': '/description', 'value': contacts.description }); }
    // if(contacts.defaultImage && contacts.defaultImage != ""){body.push({"op": "replace", "path": "/defaultImage", "value": contacts.defaultImage})}

    if (typeof contacts.image === "string" && !contacts.image.includes('blob')) body.push({ 'op': 'replace', 'path': '/avatarImage', 'value': contacts.image.replace('data:image/png;base64,', '') });
    if (typeof contacts.indoorImage === "string" && !contacts.indoorImage.includes('blob')) body.push({ 'op': 'replace', 'path': '/indoorImage', 'value': contacts.indoorImage.replace('data:image/png;base64,', '') });
    if (typeof contacts.outdoorImage === "string" && !contacts.outdoorImage.includes('blob')) body.push({ 'op': 'replace', 'path': '/outdoorImage', 'value': contacts.outdoorImage.replace('data:image/png;base64,', '') });
    if (typeof contacts.heroImage === "string" && !contacts.heroImage.includes('blob')) body.push({ 'op': 'replace', 'path': '/heroImage', 'value': contacts.heroImage.replace('data:image/png;base64,', '') });

    body.push({ 'op': 'replace', 'path': '/country', 'value': 'I' });
    body.push({ 'op': 'replace', 'path': '/city', 'value': contacts.address.city });
    body.push({ 'op': 'replace', 'path': '/province', 'value':  contacts.address.province });
    body.push({ 'op': 'replace', 'path': '/streetNumber', 'value': contacts.address.nr });
    body.push({ 'op': 'replace', 'path': '/street', 'value': contacts.address.street });
    body.push({ 'op': 'replace', 'path': '/postalCode', 'value': contacts.address.zip });
    if (contacts.address.latitudine) { body.push({ 'op': 'replace', 'path': '/latitude', 'value': parseFloat(contacts.address.latitudine) }) };
    if (contacts.address.longitudine) { body.push({ 'op': 'replace', 'path': '/longitude', 'value': parseFloat(contacts.address.longitudine) }) };
    return body;
  };

  const subscribeMerchantVas = (configuration) => $q((resolve, reject) => {
    NewBackendService.invokeWebApiPost('merchant/subscribeMerchantVAS', getSubscribeMerchantVasRequest(configuration), true).then(() => {
      LoginService.getMerchantProfile(true).then(() => {
        notifyStoreConfigChange();
        resolve();
      }, reject);
    }, reject);
  });

  const configCateringVas = configuration => $q((resolve, reject) => {
    NewBackendService.invokeWebApiPost('merchant/configCateringVas', getConfigCateringVas(configuration), true).then(() => {
      LoginService.getMerchantProfile(true).then(resolve, reject);
    }, reject);
  });

  const configCateringTaxation = (configuration) => $q((resolve, reject) => {
    getVasMerchant().then((vasMerchant) => {
      NewBackendService.invokeWebApiPost('merchant/configCateringTaxation', getConfigCateringTaxationRequest(vasMerchant, configuration), true).then(() => {
        LoginService.getMerchantProfile(true).then(resolve, reject);
      }, reject);
    }, reject);
  });

  const service = {
    setOrderAndPayEnabled: (orderAndPayEnabled) => subscribeMerchantVas({
      vasId: vasIds.ORDERANDPAY,
      vasSubscribe: orderAndPayEnabled
    }),
    setCheckinEnabled: (checkInEnabled) => subscribeMerchantVas({
      vasId: vasIds.CHECKIN,
      vasSubscribe: checkInEnabled
    }),
    setMessageOutboundEnabled: (messageOutboundEnabled) => subscribeMerchantVas({
      vasId: vasIds.MESSAGEOUTBOUND,
      vasSubscribe: messageOutboundEnabled
    }),
    setOrderAndPickEnabled: (setOrderAndPickEnabled) => subscribeMerchantVas({
      vasId: vasIds.ORDERANDPICK,
      vasSubscribe: orderAndPickEnabled
    }),
    setOrderAndDeliveryEnabled: (setOrderAndDelivery) => subscribeMerchantVas({
      vasId: vasIds.ORDERANDDELIVERY,
      vasSubscribe: orderAndDeliveryEnabled
    }),
    setOrderAtTableEnabled: (setOrderAtTable) => subscribeMerchantVas({
      vasId: vasIds.ORDERATTABLE,
      vasSubscribe: orderAtTableEnabled
    }),

    resetMerchantStoreConfiguration: () => subscribeMerchantVas({
      checkInEnabled: false,
      orderAndPayEnabled: false,
      orderAndPickEnabled: false,
      orderAndDeliveryEnabled: false,
      orderAtTableEnabled: false,
      CheckinEnabled: false
    }),
    getMerchantStoreConfiguration,
    setTaxationConfiguration: (taxationSettings, vasId) => configCateringTaxation({
      invoiceEnabled: taxationSettings.enabled | 0,
      sharePercentage: taxationSettings.vat,
      vasId
    }),
    getTaxationConfiguration: () => $q((resolve, reject) => {
      getVasMerchant().then((vasMerchant) => {
        resolve({
          enabled: _.some(vasMerchant.merchantVasViewCustomList, { invoiceEnabled: 1, invoiceExpected: 1 }),
          vat: parseFloat(vasMerchant.merchantVasViewCustomList[0].taxRate),
          activateVas: vasMerchant.merchantVasViewCustomList
        });
      }, reject);
    }),
    setCheckinConfiguration: (checkinSettings) => $q((resolve, reject) =>
      configCateringVas({
        vasId: 0,
        enabled: checkinSettings.checkin.enabled | 0,
        tableNumEnabled: checkinSettings.tables.enabled | 0
      }).then(resolve, reject)
    ),
    setOrderAndPayConfiguration: (orderAndPaySettings) => $q((resolve, reject) =>
      configCateringVas({
        vasId: 1,
        enabled: orderAndPaySettings.menu.enabled | 0,
        orderTableEnabled: orderAndPaySettings.orderAndTable.enabled | 0,
        orderPickEnabled: orderAndPaySettings.orderAndPick.enabled | 0,
      }).then(resolve, reject)
    ),
    setMessageOutboundConfiguration: (messageOutboundSettings) => $q((resolve, reject) =>
      configCateringVas({
        vasId: 2,
        enabled: messageOutboundSettings.message.enabled | 0
      }).then(resolve, reject)
    ),
    getCheckinConfiguration: () => $q((resolve, reject) => {
      getVasMerchant().then((vasMerchant) => {
        const CHECKIN = _.first(_.filter(vasMerchant.merchantVasViewCustomList, {
          vasId: vasIds.CHECKIN,
          subscriptionStatus: 1
        }));
        const ORDERANDPAY = _.first(_.filter(vasMerchant.merchantVasViewCustomList, {
          vasId: vasIds.ORDERANDPAY,
          subscriptionStatus: 1
        }));
        const MESSAGEOUTBOUND = _.first(_.filter(vasMerchant.merchantVasViewCustomList, {
          vasId: vasIds.MESSAGEOUTBOUND,
          subscriptionStatus: 1
        }));
        const configuration = {};
        if (CHECKIN) {
          configuration.checkin = {
            enabled: CHECKIN.vasEnabled === 1,
            label: CHECKIN.description
          };
          configuration.tables = {
            enabled: CHECKIN.tableNumEnabled === 1
          };
        }
        if (ORDERANDPAY) {
          configuration.menu = {
            enabled: ORDERANDPAY.vasEnabled === 1,
            label: ORDERANDPAY.description
          };
          configuration.orderAndPick = {
            enabled: ORDERANDPAY.pick === 1
          };
          configuration.orderAndTable = {
            enabled: ORDERANDPAY.atTable === 1
          };
        }
        if (MESSAGEOUTBOUND) {
          configuration.message = {
            enabled: MESSAGEOUTBOUND.vasEnabled === 1,
          };
        }
        resolve(configuration);
      }, reject);
    }),
    getMerchantContacts: (forceCall = false) => $q((resolve, reject) => {
      LoginService.getMerchantProfile(forceCall).then((merchantProfile) => {
        let puntoVendita;
        if ('punti_vendita' in merchantProfile && merchantProfile.punti_vendita.length > 0) {
          puntoVendita = merchantProfile.punti_vendita[0];
        } else if ('punto_vendita' in merchantProfile) {
          puntoVendita = merchantProfile.punto_vendita;
        }

        const contacts = {
          canEdit: false
        };

        if (puntoVendita) {
          contacts.canEdit = true;
          contacts.idPuntoVendita = puntoVendita.idpuntivendita;
          if (puntoVendita.indirizzo) {
            contacts.address = {
              listed: puntoVendita.visualizza === 1,
              zip: puntoVendita.cap,
              city: puntoVendita.citta,
              province: puntoVendita.provincia,
              street: puntoVendita.indirizzo,
              nr: puntoVendita.civico
            };
          }

          if (puntoVendita.puntoVenditaSocial) {
            _.forEach(merchantContactTypes, (type, name) => {
              const contact = _.find(puntoVendita.puntoVenditaSocial, {
                type
              });

              if (contact) {
                switch (type) {
                  case merchantContactTypes.image:
                    contacts[name] = contact.image;
                    break;
                  default:
                    contacts[name] = contact.contactInfo;
                    break;
                }
              }
            });
          }

          resolve(contacts);
        } else {
          resolve({
            canEdit: false
          });
        }
      }, reject);
    }),
    setMerchantContacts: (contacts, duplicatedMode) => NewBackendService.invokeWebApiPatch(`${endPoints.userUrl}/businesses/shops/${contacts.id}`, getSaveContactInfoRequest(contacts, duplicatedMode), true),
    /* setProfileVisibility: (idShop, visible) => $q((resolve, reject) => {
      var body = [{"op": "replace", "path": "/visible", "value": visible}]
      NewBackendService.invokeWebApiPatch(`${endPoints.userUrl}/businesses/shops/${idShop}`, body).then(resolve, reject);
    }),*/
    // Questo servizio viene chiamato nel momento in cui si attiva per la prima volta uno fra i servizi di
    // OrderAndPay o di CHECKIN
    // Il suo compito è di verificare che sia presente fra le casse almeno una attiva di tipo tablet,
    // e in quel caso eleggie la più vecchia fra queste come cassa principale (M. Avanzi)
    setTabletRegistryAsPrincipal: () => {
      MerchantDetailService.getMerchantDetail().then(lista => {
        let result = _.filter(lista.merchantDeviceList.merchantDeviceDetail, (o) => o.tablet && o.state === 'ENABLED');
        if (result.length) {
          // se c'e ne solo una eleggo quella come principale
          if (result.length !== 1) {
            // ordino per data di creazione
            result = _.sortBy(result, 'creationTime');
          }
          this.updateMerchantDevice(result[0].merchantDeviceId, result[0].state, true, true);
        }
      }, reason => $log.error('MerchantDetailService', 'getMerchantDetail', reason));
    },
    getCoordsByAddress: (indirizzo, civico, citta, cap, provincia, nazione) => $q((resolve, reject) => {
      let queryRequest = '';
      if (indirizzo) {
        queryRequest = queryRequest + indirizzo + '+';
      }
      if (civico) {
        queryRequest = queryRequest + civico + '+';
      }
      if (citta) {
        queryRequest = queryRequest + citta + '+';
      }
      if (cap) {
        queryRequest = queryRequest + cap + '+';
      }
      if (provincia) {
        queryRequest = queryRequest + provincia + '+';
      }
      if (nazione) {
        queryRequest = queryRequest + nazione;
      }
      $http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + queryRequest + '&key=' + API_KEY_GOOGLE).then(result => {
        if (result.data.status === 'OK') {
          const coords = {
            longitude: result.data.results[0].geometry.location.lng,
            latitude: result.data.results[0].geometry.location.lat
          };
          resolve(coords);
        } else {
          reject();
        }
      }, error => {
        reject(error);
      });
    }),
    qrCode: (id) => $q((resolve, reject) => {
      NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/me/qrcode/${id}/MERCHANT_DEVICE`, undefined, false, 'blob').then(
        response => {
          const blob = new Blob([response.data]);
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function onloadend() {
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = reader.result;
            a.download = `qrcode_${id}.pdf`;
            a.click();
            a.remove();
          };
          resolve(response);
        },
        error => reject(error)
      );
    }),
    /* modifyShop: (body, nazione, citta, provincia, civico, indirizzo, cap, visualizza, latitudine, longitudine) => {
      return $q((resolve, reject) => {

        return body = [
          {"op": "replace", "path": "/country", "value": nazione},
          {"op": "replace", "path": "/city", "value": citta},
          {"op": "replace", "path": "/province", "value": provincia},
          {"op": "replace", "path": "/streetNumber", "value": civico},
          {"op": "replace", "path": "/street", "value": indirizzo},
          {"op": "replace", "path": "/postalCode", "value": cap},
          {"op": "replace", "path": "/visible", "value": visualizza},
          {"op": "replace", "path": "/latitude", "value": latitudine},
          {"op": "replace", "path": "/longitude", "value": longitudine},
        ]

        NewBackendService.invokeWebApiPatch(`${endPoints.userUrl}/businesses/shops/${id}`, body, isBackground).then(function (result) {
          resolve();
        }, function (error) {
          reject(error);
        });
      });
    },*/

    updateMerchantDevice: (id, status, standalone, isBackground) => {
      const url = `${endPoints.deviceUrl}/devices/${id}`;
      return $q(function (resolve, reject) {
        let request = [
          { 'op': 'replace', 'path': '/status', 'value': status },
          { 'op': 'replace', 'path': '/standalone', 'value': standalone }
        ];
        NewBackendService.invokeWebApiPatch(url, request, isBackground).then(function (result) {
          resolve(result);
        }, function (error) {
          reject(error);
        });
      });
    },

    deleteMerchantDevice: (id) => {
      return $q(function (resolve, reject) {
        NewBackendService.invokeWebApiDelete(`${endPoints.deviceUrl}/devices/${id}`).then(function (result) {
          resolve();
        }, function (error) {
          reject(error);
        });
      }
    ); }
  };

  return service;
};

export default merchantConfigurationServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/merchantConfiguration.factory.js
 **/